// extracted by mini-css-extract-plugin
module.exports = {"sidebarFriendList":"PeopleMayKnow_sidebarFriendList__3qZ60","sidebarText":"PeopleMayKnow_sidebarText__2G5nA"};